import { ICON__upload } from '@/assets/icons_fa';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_generation } from '@/hooks/store/use_slices';
import { useToast } from '@/hooks/use-toast';
import { HOOK_GRID2D_CELL__icon_size } from '@/pages/_base/grid2d_cell/_hooks/HOOK_GRID2D_CELL__icon_size';
import { upload_many_images_to_user_task_references } from '@/utils/utils_upload';
import { DTO__grid2d } from '@shared/dto/grid2d/DTO__grid2d';

interface Props {
  grid2d: DTO__grid2d;
  width: number;
  height: number;
}

export function GRID2D_CELL__upload({ grid2d, width, height }: Props) {
  const dispatch = use_dispatch();
  const { toast } = useToast();

  const { user_task_current } = use_slice_generation(['user_task_current']);
  const { icon_width, icon_height } = HOOK_GRID2D_CELL__icon_size(width, height);

  /*
   * EVENTS
   */
  function onClick() {
    //todo: expected 5 arguments but got 4
    upload_many_images_to_user_task_references(toast, dispatch, grid2d, user_task_current._id);
  }

  /*
   * EFFECTS
   */

  /*
   * HTML
   */

  return (
    <div
      {...{ onClick }}
      className={`non-draggable
     flex justify-center items-center rounded-2xl border border-bar-border bg-transparent cursor-pointer
    
    `}
      style={{ width, height }}
    >
      <ICON__upload className="text-bar-border" style={{ width: icon_width, height: icon_height }} />
    </div>
  );
}
